<template>
	<div>
		<spinner-button :className="'btn ' + bClass" @click.prevent="reasonForm=!reasonForm" :is-pending="isPending">
			{{bLabel | trans}}
		</spinner-button>
		<b-modal v-model="reasonForm" centered hide-footer hide-header @show="onShow">
			<section class="text-left">
				<div class="form-group" :class="{ 'form-group--error': $v.reason.$error}">
					<label for="reason">{{'Reason' | trans}}</label>
					<input type="text" class="form-control" id="reason" v-model="reason" :class="status($v.reason)">
					<ul class="invalid-feedback list-unstyled text-lowercase" v-if="$v.reason.$error">
						<li v-if="!$v.reason.required">
							{{'This field is required' | trans}}
						</li>
					</ul>
				</div>
				<div class="clearfix">
					<div class="float-left mr-2">
						<b-button @click.prevent="reasonForm=!reasonForm" class="btn btn-default">{{'Cancel' | trans}}</b-button>
					</div>
					<div class="float-left">
						<b-button @click.prevent="updateStatus" class="btn btn-danger">{{'Submit' | trans}}</b-button>
					</div>
				</div>
			</section>
		</b-modal>
	</div>
</template>

<script>
	const { required } = require('vuelidate/lib/validators');
	import { validationMixin } from 'vuelidate';
	export default {
		name: "lock-unlock",
		mixins: [validationMixin],
		props: ['route', 'locked', 'id'],
		data() {
			return {
				localStatus: false,
				eventName: '',
				pendingEventName: '',
				reasonForm: false,
				reason: '',
				isPending: false
			}

		},
		mounted() {
			this.eventName = 'toggleStatus-' + this.hash32(this.id);
			this.pendingEventName = 'pendingStatus-' + this.hash32(this.id);
			this.localStatus = this.locked;
			this.EventBus.$on(this.eventName, () => {
				this.localStatus = !this.localStatus;
			});
			this.EventBus.$on(this.pendingEventName, () => {
				this.isPending = !this.isPending
			});
		},
		computed: {
			bClass() {
				return (this.localStatus? "btn-warning": "btn-danger");
			},
			bLabel() {
				return this.localStatus? "Unlock": "Lock";
			}
		},
		methods: {
			onShow() {
				this.$v.$reset();
				this.reason = '';
			},
			async updateStatus() {
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.EventBus.$emit(this.pendingEventName);
					this.reasonForm = false;
					let result = await axios.post(this.route, {
						id: this.id,
						status: this.localStatus,
						reason: this.reason
					})
					.then(result => {
						this.EventBus.$emit('event-success', Lang.get('Success'));
						this.EventBus.$emit(this.eventName);
					})
					.catch(error => {
						this.EventBus.$emit('event-error', Lang.get('Failed'));
					})
					.finally(() => {
						this.EventBus.$emit(this.pendingEventName);
					});
				}
			}
		},
		validations() {
			return {
				reason: { required }
			};
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/lock-unlock.vue